import React, { useState } from 'react'
import '../Style/Manage_Site.css'
import UserProfile from '../Components/User_Profile_Com'
import BlogIcon from '../Logos/newspaper.svg'
import ProductIcon from '../Logos/ad-product.svg'
import UserIcon from '../Logos/user.svg'
import Manage_Site_Section_Com from '../Components/Manage_Site_Section_Com'

function Manage_Site() {
    const [Section, SetSection] = useState("Blogs")
    return (
        <>
            <main>
                <div className='manage-site-container'>
                    <UserProfile />
                    <div className='second-section-container'>
                        <div className='sections-list-container'>
                            <div className='section-row' onClick={() => {SetSection("Blogs")}}>
                                <img src={BlogIcon} className='sections-icons'/>
                                <div className='section-text'>بلاگ ها</div>
                            </div>
                            <div className='section-row' onClick={() => {SetSection("Products")}}>
                                <img src={ProductIcon} className='sections-icons'/>
                                <div className='section-text'>محصولات</div>
                            </div>
                            <div className='section-row' onClick={() => {SetSection("Accounts")}}>
                                <img src={UserIcon} className='sections-icons'/>
                                <div className='section-text'>حساب ها</div>
                            </div>
                        </div>
                        {Section === "Blogs" ? <Manage_Site_Section_Com Section={"Blogs"} /> : null}
                        {Section === "Products" ? <Manage_Site_Section_Com Section={"Products"}/> : null}
                        {Section === "Accounts" ? <Manage_Site_Section_Com Section={"Accounts"}/> : null}
                    </div>
                </div>
            </main>
        </>
    )
}

export default Manage_Site